import { MailWarning } from "lucide-react";

const when = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

// Delivery of the newest owner alert email: a banner the moment a send fails, a quiet line otherwise.
export const AlertEmailStatus = ({ email }) => {
  if (!email) return null;
  const failing = email.status === "retrying" || email.status === "failed";
  if (!failing) {
    const what = email.status === "sent" ? `sent ${when(email.sent_at)}${email.note ? ` (${email.note})` : ""}`
      : email.status === "skipped" ? "not sent (OWNER_ALERT_EMAIL is not set)" : "waiting to be sent";
    return (
      <p data-testid="alert-email-status" className="mt-4 text-xs text-muted-foreground">
        Last alert email: {what}.
      </p>
    );
  }
  return (
    <div data-testid="alert-email-failed-banner" className="mt-6 rounded-2xl border border-rose-300 bg-rose-50 text-rose-900 px-4 py-3 flex items-start gap-3">
      <MailWarning className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <p className="font-bold">The owner alert email could not be sent</p>
        <p className="mt-1">
          Alert: {email.reason}
        </p>
        <p data-testid="alert-email-failed-reason" className="mt-1">
          {email.last_status_code ? `HTTP ${email.last_status_code}: ` : ""}{email.last_error} · {email.attempts} attempt{email.attempts === 1 ? "" : "s"}
        </p>
        <p data-testid="alert-email-next-try" className="mt-1 text-xs opacity-80">
          {email.status === "failed"
            ? "Gave up after 24 hours of retries. Builds are not affected."
            : `Next try ${when(email.next_try_at)} (after 1, 5, 15 and 60 minutes, then hourly for 24 h). Builds are not affected.`}
        </p>
      </div>
    </div>
  );
};
